import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { D3LinePlotVM } from './D3LinePlotVM';
import './d3LinePlot.scss';

const D3LinePlotComponent = (props) => {
  // create a view-model that will persist for the lifetime of the component
  const vm = useRef(new D3LinePlotVM(props)).current;
  React.useEffect(() => {
    vm.initPlotArea();
    const plotConfig = {
      targetElementID: props.targetDivID,
      windowOptions: props.windowOptions,
    };

    vm.drawLinePlot(props.plotData, plotConfig);
  }, [props.plotData]);

  return (
    <div>
      <div id={props.targetDivID}></div>
    </div>
  );
};

// export a D3LinePlotComponent wrapped in observer - whenever the D3LinePlot is changed, RainfallDischargeDataComponent will be re-rendered
export const D3LinePlot = observer(D3LinePlotComponent);
